import { render } from "./MainLayoutHospital.vue?vue&type=template&id=0584f694&scoped=true"
import script from "./MainLayoutHospital.vue?vue&type=script&lang=js"
export * from "./MainLayoutHospital.vue?vue&type=script&lang=js"

import "./MainLayoutHospital.vue?vue&type=style&index=0&id=0584f694&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0584f694"]])

export default __exports__